import React, { useState, useEffect } from "react";
import isEmail from "validator/lib/isEmail";
import CartInputField from "../Components/Cart/CartInputField";

function PasswordRecovery(props) {
  const [FormEmail, setFormEmail] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [NetError, setNetError] = useState(null);
  const [ErrorList, setErrorList] = useState([]);
  const [Message, setMessage] = useState("");

  useEffect(() => {
    setMessage("");
  }, [FormEmail]);

  function passwordRecoveryHandler(e) {
    e.preventDefault();
    var errList = [];

    if (FormEmail.trim().length === 0 || !isEmail(FormEmail)) {
      errList.push({
        id: "Email",
        msg: "Inserire un indirizo di email valido.",
      });
    }

    setErrorList(errList);
    //console.log(errList);

    if (errList.length > 0) {
      setMessage(
        "La compilazione dei dati è errata. Segui le indicazioni e riprova!"
      );
      return;
    } else {
      setMessage("");
    }
    let params = [
      { name: "id_sessione", value: props.sessionKey },
      { name: "email", value: FormEmail },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/recupera_psw_cliente",
      IsLoading,
      setIsLoading,
      NetError,
      setNetError,
      params,
      (respData) => {
        console.log(respData);
        //setValidatedEmail("");
        let txt = "";
        if (respData.status === "true") {
          txt = respData.message;
          //txt = "Recupero avvenuto con successo. Ti abbiamo inviato una e-mail contenente i nuovi dati di accesso.";
        } else {
          txt = respData.message;
        }
        setMessage(txt);
      }
    );
  }

  //console.log(Message);
  //console.log(ErrorList);
  return (
    <>
      <div className="contenitore_01">
        <div className="contenuto_recuperopwd">
          <h1>Recupero password</h1>
          <p>
            Inserisci il tuo indirizzo e-mail nel campo sottostante e riceverai
            una e-mail contenente una nuova password di accesso.
          </p>
          <form onSubmit={(e) => passwordRecoveryHandler(e)}>
            <CartInputField
              required={true}
              type="text"
              lbl=""
              name="Email"
              placeholder="E-mail"
              value={FormEmail}
              change={setFormEmail}
              cssClass="riga_email_recuperopwd"
              errList={ErrorList}
            />
            {Message.length > 0 ? <p>{Message}</p> : null}
            {NetError !== null ? <p>Operazione fallita: {NetError}</p> : null}
            <div
              className="invia_recuperopwd_button"
              onClick={(e) => passwordRecoveryHandler(e)}
            >
              Invia
            </div>
          </form>
        </div>
      </div>
     </>
  );
}

export default PasswordRecovery;